    import { Link } from 'react-router-dom'
    const Library = () => {
        return (
            <>
                <div className="breadcrumb">
                    <h2>School Library</h2>
                    <ul>
                        <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                        <li>|</li>
                    <li>Rules</li>
                    <li>|</li>
                        <li>School Library</li>
                    </ul>
                </div>
                <div className="inner_page uniform_section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <ul className="list-view">
                                    <li>Strict discipline and silence is to be observed in the library and reading room.</li>
                                    <li>Library books will be issued to the senior classes which can be returned only during Library period. Anyone failing to return the books on the due date shall incur a fine or RS.10/-per day.</li>
                                    <li>Periodicals/Magazines are to be red in the Library/Reading Room only and the same are to be placed in their specific places after use.</li>
                                    <li>If necessary the Librarian/principal may recall a book at any time.</li>
                                    <li>Marking, underlining, cutting, erasing or damaging of the books are strictly prohibited. Any damage or loss of library books shall be restituted by replacement of the book or by paying its cost with an additional fine by the borrower according to the discretion of the Librarian/Principal.</li>
                                    <li>Al pupils from VI onward must read a minimum of 10 English books, 8 Hindi books and 8 Punjabi books in a year. A one page summary of each book read must be shown to the class teacher or else 2 marks for every book not thus read will be deducted form English, Hindi and Punjabi paper in the final examination.</li>
                                    
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    export default Library
